import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Page',
    component: () => import('../views/Page.vue'),
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('../views/HomeView.vue')
      }
    ],
  },  
  {
    path: '/login',
    name: 'LoginView',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/register',
    name: 'RegisterView',
    component: () => import('../views/RegisterView.vue')
  },
  {
    path: '/qikan',
    name: 'QikanView',
    component: () => import('../views/QikanView.vue')
  },
  {
    path: '/qikandetail',
    name: 'QikanDetail',
    component: () => import('../views/QikanDetail.vue')
  },
  {
    path: '/about',
    name: 'AboutUs',
    component: () => import('../views/AboutUs.vue')
  },
  {
    path: '/server',
    component: () => import('../views/OthersView.vue'),
    children: [
      {
        path: 'partBook',
        component: () => import('../components/partBook.vue'),
      },
      {
        path: 'partQuer',
        component: () => import('../components/partQuer.vue'),
      },
      {
        path: 'partEva',
        component: () => import('../components/partEva.vue'),
      },
      {
        path: 'partAcad',
        component: () => import('../components/partAcad.vue'),
      },
      {
        path: 'partMate',
        component: () => import('../components/partMate.vue'),
      },
      {
        path: 'partCert',
        component: () => import('../components/partCert.vue'),
      },
    ]
  },
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
